import { Pipe, PipeTransform } from '@angular/core';
import { SubscriptionStatus } from '../../models/enums/subscription.enums';

@Pipe({
  name: 'subscriptionStatus',
})
export class SubscriptionStatusPipe implements PipeTransform {
  transform(status: SubscriptionStatus): string {
    switch (status) {
      case SubscriptionStatus.NOT_STARTED:
        return $localize`En attente`;
      case SubscriptionStatus.ACTIVE:
        return $localize`Active`;
      case SubscriptionStatus.PAYMENT_FAILED:
        return $localize`Paiement échoué`;
      case SubscriptionStatus.PAYMENT_PENDING:
        return $localize`Paiement en cours`;
      case SubscriptionStatus.CLOSED:
        return $localize`Annulée`;
      case SubscriptionStatus.ENDED:
        return $localize`Terminée`;
      default:
        return '';
    }
  }
}
